import { jsxs as e, Fragment as o, jsx as t } from "react/jsx-runtime";
import { useState as r } from "react";
import { StatusChip as i } from "../../../../common/components/StatusChip.js";
import { FileUpload as n } from "../../FileUpload.js";
import l from "@mui/icons-material/InfoOutlined";
import { Stack as c } from "@mui/joy";
import m from "@mui/joy/Typography";
const p = ({ onChange: p2, onRemoveFile: a, accept: h, acceptLabel: s, title: d, subtitle: f }) => {
  const [g, x] = r([]), [u, y] = r([]);
  return e(o, { children: [e(c, { gap: 0.5, children: [e(c, { direction: "row", justifyContent: "space-between", children: [t(m, { level: "body-md", sx: { fontWeight: 600, color: "#23293A" }, children: d }), e(c, { direction: "row", gap: 0.5, alignItems: "center", children: [t(m, { level: "body-xs", sx: { color: "#23293A" }, children: "Обрані файли" }), t(i, { color: "grey", title: `${g.length + u.length} / 1` })] })] }), e(c, { flexDirection: "row", gap: 0.5, children: [f && t(l, { style: { width: "16px", height: "16px", color: "#616778" } }), t(m, { textColor: "neutral.500", sx: { fontSize: "12px" }, children: f })] })] }), t(n, { onChange: (e2) => {
    x(e2), p2(e2);
  }, onRemoveFile: (e2) => {
    y(e2), a == null ? void 0 : a(e2);
  }, accept: h, acceptLabel: s, maxFiles: 1 })] });
};
export {
  p as ReadingFiles
};
//# sourceMappingURL=ReadingsFiles.js.map
